import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Banner, ButtonClean, useModalContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import type { Product } from '../../../../../../__models__'
import { useOfferMigrateProductOptionsQuery } from '../../../../hooks/useOfferMigrateProductOptionsQuery/useOfferMigrateProductOptionsQuery'
import { ChangeToAnotherProductModal } from '../ChangeToAnotherProductModal/ChangeToAnotherProductModal'

type ProductDiscontinuedBannerProps = {
  offerId: string
  product: Product
}

export const ProductDiscontinuedBanner = ({ offerId, product }: ProductDiscontinuedBannerProps) => {
  const navigate = useNavigate()
  const { open, close } = useModalContext()
  const { offerMigrateProductOptionsQuery } = useOfferMigrateProductOptionsQuery([{ offerId }])

  const handleClick = () => {
    open(ChangeToAnotherProductModal, {
      offerId,
      async onConfirm(duplicatedOfferId) {
        navigate(reverse(routing.products.all.product.self, { productId: duplicatedOfferId }))
      },
      onClose() {
        close()
      },
    })
  }

  if (
    offerMigrateProductOptionsQuery.isFetching ||
    offerMigrateProductOptionsQuery.data?.migrationOptions.length === 0
  ) {
    return null
  }

  return (
    <Banner appearance="warning">
      <p>
        {product?.name} has been discontinued and is no longer available.{' '}
        <ButtonClean label="Offer this design on a similar product" onClick={handleClick} />
      </p>
    </Banner>
  )
}
